import pdfMake from 'pdfmake/build/pdfmake'
import moment from 'moment-timezone'
import { logoImg } from '../../../../services/others/assets'

// 订单审批后发给客户的 Order Summary。data 为 SalesOrder/GetAllOrder 返回的原始订单，
// 金额全部用数据库里的值（行价 price、GST priceInclgst、总价 totalPrice），不在这里重新计算
export default async (data: any): Promise<Blob> => {
  const vfsFonts = await import('pdfmake/build/vfs_fonts')
  const { vfs } = vfsFonts.pdfMake
  pdfMake.vfs = vfs

  // 后端是 UTC，转成 NZ 本地日期
  const formatDate = (date: any) => (date ? moment.utc(date).tz('Pacific/Auckland').format('DD/MM/YYYY') : '')
  const money = (n: any) => `$${Number(n || 0).toFixed(2)}`

  const productRows = (data.orderProduct || []).map((item: any) => [
    item.product?.productCode || '',
    item.product?.productName || '',
    { text: item.quantity, alignment: 'center' },
    { text: item.product?.baseProduct?.packagingType?.quantity || '', alignment: 'center' },
    { text: money(item.unitPrice), alignment: 'right' },
    { text: money(item.price), alignment: 'right' }
  ])

  const optionRows = (data.orderOption || []).map((item: any) => [
    '',
    item.option?.optionName || '',
    { text: item.quantity, alignment: 'center' },
    '',
    { text: money(item.unitPrice), alignment: 'right' },
    { text: money(item.price), alignment: 'right' }
  ])

  const totalRow = (label: string, value: any, bold = false) => [
    { text: label, colSpan: 5, alignment: 'right', bold }, '', '', '', '',
    { text: money(value), alignment: 'right', bold }
  ]

  const deliveryAddress = [data.deliveryAddress, data.deliveryCity?.cityName, data.postalCode].filter(Boolean).join(', ')

  const documentDefinition: any = {
    pageSize: 'A4',
    pageOrientation: 'portrait',
    pageMargins: [40, 40, 40, 50],
    info: {
      title: `Order Summary ${data.orderNo}`,
      author: 'Jadcup',
      subject: `Order Summary ${data.orderNo}`,
      keywords: 'Jadcup'
    },
    defaultStyle: { fontSize: 9 },
    content: [
      {
        columns: [
          { image: logoImg, width: 60 },
          {
            stack: [
              { text: 'ORDER SUMMARY', bold: true, fontSize: 18, color: '#335627' },
              { text: `Order No: ${data.orderNo || ''}` },
              data.custOrderNo ? { text: `PO No: ${data.custOrderNo}` } : null,
              { text: `Order Date: ${formatDate(data.orderDate)}` },
              { text: `ETA: ${formatDate(data.requiredDate)}` }
            ].filter(Boolean),
            alignment: 'right'
          }
        ]
      },
      {
        margin: [0, 20, 0, 0],
        columns: [
          {
            stack: [
              { text: 'Customer', bold: true, margin: [0, 0, 0, 4] },
              { text: data.customer?.company || '' },
              { text: data.customer?.customerCode || '' },
              { text: data.customer?.email || '' },
              { text: data.customer?.phone || data.customer?.mobile || '' }
            ]
          },
          {
            stack: [
              { text: 'Delivery', bold: true, margin: [0, 0, 0, 4] },
              { text: data.deliveryName || '' },
              { text: deliveryAddress },
              { text: data.deliveryMethod?.deliveryMethodName || '' }
            ]
          }
        ]
      },
      {
        margin: [0, 20, 0, 0],
        table: {
          headerRows: 1,
          widths: [60, '*', 45, 50, 60, 65],
          body: [
            ['Item Code', 'Description', 'Cartons', 'Qty/Carton', 'Unit Price', 'Amount'].map((text, i) => ({
              text, bold: true, color: 'white', fillColor: '#335627', alignment: i < 2 ? 'left' : (i < 4 ? 'center' : 'right')
            })),
            ...productRows,
            ...optionRows,
            totalRow('GST', data.priceInclgst),
            totalRow('Total (incl. GST)', data.totalPrice, true)
          ]
        },
        layout: 'lightHorizontalLines'
      },
      data.warehouseNote ? { margin: [0, 16, 0, 0], text: [{ text: 'Delivery Instruction: ', bold: true }, data.warehouseNote] } : null,
      { margin: [0, 24, 0, 0], text: 'Thank you for your order. Please contact us if any of the details above are incorrect.' }
    ].filter(Boolean),
    footer: () => ({
      alignment: 'center',
      lineHeight: 1.2,
      text: 'Email: order@jadcup.co.nz       Phone: +64 9 282 3988        www.jadcup.co.nz \nAdd: 17b Landing Drive, Māngere, Auckland 2022, New Zealand',
      fontSize: 8
    })
  }

  return new Promise(resolve => pdfMake.createPdf(documentDefinition).getBlob((blob: Blob) => resolve(blob)))
}
